<div class="form-input textarea">
  <div class="desc-icon">
      <app-tooltip-icon *ngIf="fieldConfig.description!=undefined"
                        [description]="fieldConfig.description"></app-tooltip-icon>
  </div>

  <mat-form-field *ngIf="fieldConfig.maskConfig">
      <textarea matInput
             cdkTextareaAutosize
             #autosize="cdkTextareaAutosize"
             cdkAutosizeMinRows="1"
             id="{{fieldConfig.fieldKey + 'MaskInput'}}"
             (blur)="onBlur($event)"
             (click)="onClick($event)"
             [readonly]="fieldConfig.readonly"
             [placeholder]="fieldConfig.caption|translate"
             [formControl]="control"
             [type]="(fieldConfig.properties && fieldConfig.properties.inputText)? fieldConfig.properties.inputText : 'text'"
             [name]="fieldConfig.key"
             [mask]="mask"
             [dropSpecialCharacters]="dropSpecialCharacters"
             [patterns]="patterns"></textarea>

      <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' + fieldConfig.fieldKey + '.' +
          errorsMap.get(fieldConfig.fieldKey))|translate}}
      </mat-error>

  </mat-form-field>

  <mat-form-field *ngIf="!fieldConfig.maskConfig">
      <textarea appTextTransform
             matInput
             cdkTextareaAutosize
             #autosize="cdkTextareaAutosize"
             cdkAutosizeMinRows="1"
             id="{{fieldConfig.fieldKey + 'Input'}}"
             [readonly]="fieldConfig.readonly"
             (blur)="onBlur($event)"
             (click)="onClick($event)"
             [type]="(fieldConfig.properties && fieldConfig.properties.inputText)? fieldConfig.properties.inputText : 'text'"
             [placeholder]="fieldConfig.caption|translate"
             [formControl]="control"
             [name]="fieldConfig.fieldKey"></textarea>

      <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' + fieldConfig.fieldKey + '.' +
          errorsMap.get(fieldConfig.fieldKey))|translate}}
      </mat-error>

  </mat-form-field>
</div>
